<template>
  <div class="page-wrapper">
    <div class="row justify-between items-start">
      <h1>Услуги <span class="data-rows-number">{{ projectServicesTotal }}</span></h1>
      <service-create
        v-if="ownerId"
        @save="$refs.servicesList.updateServicesList()"
      />
    </div>
    <services-list
      v-if="ownerId"
      ref="servicesList"
    />
    <div v-else>
      Для работы с услугами необходимо указать <router-link :to="`/projects/${this.$route.params.id}#client`">клиента</router-link>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex';
  import ServicesList from '@/ServicesList';
  import ServiceCreate from '@/ServiceCreate';

  export default {
    name: 'Services',
    components: {
      ServicesList,
      ServiceCreate
    },
    data () {
      return {};
    },
    computed: mapGetters({
      projectServicesTotal: 'servicesList/total',
      ownerId: 'project/ownerId'
    })
  };
</script>


// WEBPACK FOOTER //
// resources/assets/js/views/ProjectServicesView.vue